const descriptions: Record<string, string> = {
  policy_blocked: "ລູກຄ້າຕ້ອງທັກ Page ກ່ອນ ແລ້ວຈຶ່ງສົ່ງໃໝ່",
  outside_24h_no_utility: "ເກີນ 24 ຊົ່ວໂມງ — ໃຫ້ລູກຄ້າທັກ Page ກ່ອນ ແລ້ວສົ່ງໃໝ່",
  utility_template_unavailable: "Page ຍັງບໍ່ມີ Meta utility template ທີ່ອະນຸມັດ",
  order_already_paid: "ອໍເດີນີ້ຊຳລະຄົບແລ້ວ",
  order_not_payable: "ອໍເດີຖືກຍົກເລີກ / ສົ່ງແລ້ວ / ບໍ່ມີຍອດຄ້າງ",
  payment_deadline_expired: "ໝົດກຳນົດຊຳລະແລ້ວ",
  no_customer_fb_id: "ບໍ່ພົບ Facebook ຂອງລູກຄ້າ",
  shop_order_not_linked: "ອໍເດີຍັງບໍ່ຜູກກັບບິນຂາຍ",
  template_disabled: "ຂໍ້ຄວາມທວງຍອດຖືກປິດໄວ້",
  page_not_enabled: "Page ຍັງບໍ່ເປີດສົ່ງ Messenger",
  recipient_not_resolved: "ຍັງຫາ Messenger ຂອງລູກຄ້າບໍ່ພົບ",
  duplicate_event: "ລາຍການນີ້ຖືກສົ່ງໄປແລ້ວ",
};

export function reminderReasonDescription(reason?: string | null): string {
  return (
    (reason && descriptions[reason]) || "ກະລຸນາກວດສອບ Messenger ແລະການຕັ້ງຄ່າຂໍ້ຄວາມ"
  );
}
